<template>
  <div>
    <table-view
      ref="tableList"
      is-search-row
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="MAIL LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void (0)"
          class="icon-pencil1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleEdit(tableRow.row)"
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="900px"
      @close="handleClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <el-form-item label="Title" prop="title">
            <el-input
              style="width: 100%"
              v-model="form.title"
              :disabled="disabled"
            />
          </el-form-item>
          <el-form-item label="Email Subject" prop="subject">
            <el-input style="width: 100%" v-model="form.subject" />
          </el-form-item>
          <el-form-item label="Email Body" prop="body">
            <div id="editor"></div>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button style="margin-right: 20px" @click="visible = false">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSave">
          Save
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTableData, updateOrAdd, removeItem } from './api'
import wangEditor from 'wangeditor'
import i18next from 'i18next'
window.i18next = i18next

export default {
  data() {
    const tableModel = [
      {
        label: 'Title',
        prop: 'title',
      },
      {
        label: 'Update Time',
        prop: 'createTime',
      },
      {
        label: 'Action',
        width: 120,
        slotName: 'action',
      },
    ]
    return {
      disabled: false,
      tableModel: tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        title: '',
        subject: '',
        body: '',
      },
      rules: {
        title: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
        subject: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
        body: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
      },
      editorOption: {},
      editor: null,
    }
  },
  mounted() {
    this.initTable()
  },
  beforeDestroy() {
    this.editor.destroy()
    this.editor = null
  },
  methods: {
    initEditor() {
      const editor = new wangEditor(`#editor`)
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.config.onchange = newHtml => {
        this.form.body = newHtml
      }
      editor.config.lang = 'en'
      // 引入 i18next 插件
      editor.i18next = window.i18next
      // 创建编辑器
      editor.create()
      this.editor = editor
    },
    escapeStringHTML(str) {
      str = str.replace(/&lt;/g, '<')
      str = str.replace(/&gt;/g, '>')
      return str
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    handleClose() {
      this.formId = ''
      this.$refs.form.resetFields()
    },
    async handleSave() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          const submitData = { ...this.form }
          if (this.formId) submitData.id = this.formId
          await this.handleUpdateOrAdd(submitData)
        }
      } catch (err) {
        console.error(err)
      }
    },
    async handleUpdateOrAdd(params) {
      try {
        await updateOrAdd(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    async handleTitleActionBtn() {
      this.visible = true
      this.disabled = false
      this.$nextTick(() => {
        this.initEditor()
      })
    },
    handleEdit(row) {
      this.visible = true
      this.disabled = true
      this.formId = row.id
      this.$nextTick(() => {
        Object.keys(this.form).forEach(key => {
          if (key === 'body') {
            this.form[key] = this.escapeStringHTML(row[key])
          } else {
            this.form[key] = row[key]
          }
        })
        this.initEditor()
        this.editor.txt.append(this.form.body)
      })
    },
    async handleRemoveItem(id) {
      try {
        await removeItem(id)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.editor {
  overflow: hidden;
}
:deep(.el-form-item__content) {
  width: 100%;
}
</style>
